import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';
import { TicketsComponent } from './tickets.component';
import { TicketsService } from './tickets.service';
import { TicketsDetalleComponent } from './detalle/tickets-detalle.component';
import { TicketsEditarComponent } from './editar/tickets-editar.component';
import { ContentService } from '../content.service';
import { ActivosService } from '../activos/activos.service';
import { FileManagerService } from '../file-manager/file-manager.service';
import { ListaAdjuntosComponent } from './components/lista-adjuntos/lista-adjuntos.component';
import { FuseWidgetModule } from '../../../core/components/widget/widget.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SelectorModule } from '../selector/selector.module';

const routes = [
    {
        path     : 'tickets',
        component: TicketsComponent
    },
    {
        path     : 'tickets/detalle/:idTicket',
        component: TicketsDetalleComponent
    },
    {
        path     : 'tickets/editar/:idTicket',
        component: TicketsEditarComponent
    },
    {
        path     : 'tickets/nuevo',
        component: TicketsEditarComponent
    },
    {
        path     : 'tickets/:idActivo',
        component: TicketsComponent
    },
    {
        path     : 'tickets/nuevo/:idActivo',
        component: TicketsEditarComponent
    }
];

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forChild(routes),
        FuseWidgetModule,
        BrowserAnimationsModule,
        SelectorModule
    ],
    declarations: [
        TicketsComponent,
        TicketsDetalleComponent,
        TicketsEditarComponent,
        ListaAdjuntosComponent
    ],
    providers: [TicketsService, ContentService, ActivosService, FileManagerService]
})
export class TicketsModule {
}



// WEBPACK FOOTER //
// ./src/app/main/content/tickets/tickets.module.ts